angular.module('octopusApp.projects')
    .controller('ProjectLayoutController', function($scope, projectState) {
        var self = $scope;
        self.project = null;
        self.projectId = projectState.projectId;
        self.isLoading = projectState.isLoading;
        self.isSaving = projectState.isSaving;
        self.suppressCreateRelease = false;

        $scope.$watch(function () {
            return projectState.deploymentProcess;
        }, function(deploymentProcess) {
            self.suppressCreateRelease = !deploymentProcess || deploymentProcess.Steps.length < 1;
        });

        $scope.$watch(function () {
            return projectState.project;
        }, function (project) {
            self.project = project;
        });
    }).provider('projectState', function() {
        this.$get = function($stateParams, $timeout, busy, octopusRepository) {
            var state = {
                isLoading: busy.create(),
                isSaving: busy.create(),
                projectId: $stateParams.projectId,
                project: null,
                projectAsync: null,
                deploymentProcessAsync: null,
                deploymentProcess: null
            };

            function load() {
                state.projectAsync = octopusRepository.Projects.get(state.projectId).then(function (project) {
                    state.deploymentProcessAsync = octopusRepository.DeploymentProcesses.get(project.DeploymentProcessId).then(function(deploymentProcess) {
                        return (state.deploymentProcess = deploymentProcess);
                    });
                    state.isLoading.promise(state.deploymentProcessAsync);
                    return (state.project = project);
                });
                state.isLoading.promise(state.projectAsync);

                return state.projectAsync;
            }

            $timeout(function() {
                if (!state.projectAsync) {
                    console.warn("Project State was not populated by content controller.");
                    load();
                }
            }, 5000);

            state.load = load;
            return state;
        };
    });


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_layout_controller.js
// module id = 516
// module chunks = 1